import Tooltip from '@ui-kit/components/tooltip';
import React from 'react';
import { TablePointsInfo } from './tablePointsDialog/tablePointsInfo';

type PropsType = {
  halfPoints: string;
  fullPoints: {
    table: number;
    matchStringLong: string;
    timePerMoveStringL: string;
  };
  children?: never;
};

export const TablePoints = ({ fullPoints, halfPoints }: PropsType) => {
  return (
    <Tooltip
      overlay={<TablePointsInfo fullPoints={fullPoints} />}
      placement="bottom"
      trigger="hover"
    >
      <div className="table-list__points table-list__content-playing-item invites__content-points">
        {halfPoints}
      </div>
    </Tooltip>
  );
};
